import { Button } from "@jsq/ds/core";
import { useInvestorWizard } from "../context";
import { useCreateCase } from "./useCreateCase";

export const ReviewFooter = () => {
  const { goBack } = useInvestorWizard();
  const { handleCreateCase, submitting, programsLoading } = useCreateCase();

  return (
    <>
      <Button variant="neutral" onClick={goBack}>
        Back
      </Button>
      <Button
        variant="primary"
        onClick={() => void handleCreateCase()}
        isLoading={submitting}
        disabled={submitting || programsLoading}
      >
        Create case
      </Button>
    </>
  );
};
